import $ from 'jquery';

import BasePropertyView from 'BasePropertyView.js'
import contentTemplate from 'properties/style/advanced-background-color.ejs';
import themeService from 'ThemeService.js';
import util from 'util/Util.js';
import { pickerCfg } from 'pickerCfg.js';
import listService from 'ListService';
import constants        from 'Constants';
class StyleAdvancedBackgroundColorView extends BasePropertyView {

    initialize(opts) {
        super.initialize(opts);

        this.options = opts || {};
        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=text]': 'updateColorAttributesWithValidation',
            'change input[type=color]': 'updateColorAttributes',
            'blur input[type=text]': 'lostFocus',
            'focus input[type=text]': 'getFocus'
        };

        let mobileDesignerStyle = listService.mainKind === constants.KIND_MOBILE ? "display: none;" : "";
        this.model.set('mobileDesignerStyle', mobileDesignerStyle, constants.MODEL_SILENT);

        return this;
    }

    render() {
        super.render();

        let props = this.resolveThemeColors(this.model, ['advancedBgColorOver','advancedBgGradientColorOver','advancedBgColorDown','advancedBgGradientColorDown']);

        this.$el.html(this.template(props));

        //.$('input[type=color]', this.$el).spectrum(pickerCfg);

        this.delegateEvents();

        return this;
    }

}

export default StyleAdvancedBackgroundColorView;
